<template>
  <div class="caseAll">
    <Personal-center-head>
      <div>我的病例</div>
      <template slot="revert">
        <div class="revert">返回</div>
      </template>
    </Personal-center-head>

    <div class="caseAll-content">
      <el-table
        :data="aprenderObject.list"
        style="width: 100%"
        @cell-click="tableClick"
      >
        <el-table-column
          label="封面图"
          width="260"
        >
          <template slot-scope="scope">
            <div class="caseAll-content-item-img">
              <img :src="scope.row.image">
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="病例名称"
          width="450"
        >
          <template slot-scope="scope">
            <div>{{scope.row.title}}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="发布时间"
          width="260"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.create_time }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <div class="operate">
              <div
                v-if="scope.row.status!=1"
                @click.stop="editClick(scope.$index, scope.row)"
              ><img src="../../../assets/image/edit.png">
              </div>
              <div @click.stop="deleteClick(scope.$index, scope.row)"><img
                  src="../../../assets/image/delete.png"
                >
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态">
          <template slot-scope="scope">
            <!-- //! 状态不对需要修改  -->
            <div
              class="active-g"
              v-if="scope.row.status==0"
            >未审核</div>
            <div
              class="active-y"
              v-if="scope.row.status==1"
            >已审核</div>
            <div
              class="active-r"
              v-if="scope.row.status==2"
            >驳回</div>
          </template>
        </el-table-column>

        <el-table-column label="意见">
          <template slot-scope="scope">
            <div>{{scope.row.reason}}</div>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div
      class="page"
      v-show="aprenderObject.list!=0"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="aprenderObject.pages"
        :current-page.sync="currentPage"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import PersonalCenterHead from '../../../components/PersonalCenterHead/index'
export default {
  name: 'caseAll',
  components: {
    PersonalCenterHead
  },
  data () {
    return {
      aprenderObject: {},
      total: 0,//总条目数
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数   
    }
  },
  created () {
    //this.$Spin.show();
    this.getBlMy()
  },
  methods: {
    //获取我的病例列表
    async getBlMy () {
      const { data: data } = await this.$http.post("bl/my", { page: this.currentPage, limit: this.pagesize })
      this.aprenderObject = data.data
      this.$Spin.hide();
    },
    //详情
    tableClick (row) {
      this.$router.push({
        path: '/Casedetail',
        query: {
          id: row.id
        }
      })
    },
    //编辑
    editClick (index, item) {
      this.$router.push({
        path: '/Caseeditor',
        query: {
          id: item.id
        }
      })
    },
    //删除
    deleteClick (index, item) {
      this.$confirm('您是否要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('bl/del', {
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getBlMy()
      })
    },

    sizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    //点击每一页  
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getBlMy()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getBlMy()
      }, 500)
      this.$Spin.show();
    },
    //下一页 
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getBlMy()
      }, 500)
      this.$Spin.show();
    },
  }
}

</script>
<style lang="less" scoped>
.caseAll {
  padding: 0 0 50px 0;
  height: 91.5%;
  position: relative;

  .caseAll-content {
    width: 100%;
    min-height: 100%;
    // height: 100%;
    margin-top: 23px;
    padding: 25px 20px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;
    overflow: hidden;

    .caseAll-content-item-img {
      width: 160px;
      height: 80px;
      border-radius: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .operate {
      width: 72px;
      height: 36px;
      border: 1px solid #f1f1f1;
      display: flex;
      div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      :nth-child(1) {
        border-right: 1px solid #f1f1f1;
      }
    }

    .active-g {
      color: #41ab1b;
    }
    .active-r {
      color: #e41010;
    }
    .active-y {
      color: #fc9c0d;
    }
  }
  /deep/ .el-table th.el-table__cell > .cell {
    color: #212529;
    font-size: 16px;
  }

  /deep/ .el-table .el-table__cell {
    padding: 13px 0;
  }

  .paging {
    position: absolute;
    bottom: -75px;
    right: -10px;
  }

  .page {
    margin-top: 15px;
    text-align: right;
    padding-bottom: 4px;
  }
  /deep/ .el-table__row {
    cursor: pointer;
  }
}
</style>